export default "__VITE_ASSET__DNqaWRZw__"